import { render } from "./TheBreadcrumb.vue?vue&type=template&id=57227fca&scoped=true"
import script from "./TheBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TheBreadcrumb.vue?vue&type=script&lang=js"

import "./TheBreadcrumb.vue?vue&type=style&index=0&id=57227fca&scoped=true&lang=css"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57227fca"]])

export default __exports__